import { useState, useEffect, ReactNode } from 'react';

import { DarkModeContext } from './DarkmodeContext';

type Props = { children: ReactNode };

export const DarkModeProvider = ({ children }: Props) => {
  const [isDarkMode, setIsDarkMode] = useState(
    () => typeof window !== 'undefined' && localStorage.getItem('theme') === 'dark'
  );

  useEffect(() => {
    if (isDarkMode) {
      document.documentElement.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      document.documentElement.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [isDarkMode]);

  return <DarkModeContext value={{ isDarkMode, setIsDarkMode }}>{children}</DarkModeContext>;
};
